import React from "react";

import { toClassName } from "@src/multiCustodian/utils/to-class-name";

import styles from "./UnseenNotificationsCount.module.css";

const CAP_LIMIT = 99;

interface UnseenNotificationsCountProps {
  unseenCount: number | undefined;
}

const UnseenNotificationsCount: React.FC<UnseenNotificationsCountProps> = ({
  unseenCount = 0,
}) => {
  if (unseenCount <= 0) {
    return null;
  }

  const isCapped = unseenCount > CAP_LIMIT;
  const cappedUnseenCount = isCapped ? CAP_LIMIT : unseenCount;

  return (
    <div className={styles.container}>
      <div className={styles.unseenCount}>{cappedUnseenCount}</div>
      {isCapped && (
        <span
          className={toClassName(styles.unseenCount, styles.unseenCountCap)}
        >
          +
        </span>
      )}
    </div>
  );
};

export default UnseenNotificationsCount;
